import React, { useEffect, useState } from "react";
import CustomSelect from "../UI Component/CustomSelect/CustomSelect";
import DelayTimeWrapper from "./DelayTimeWrapper";
import "./style.scss";
import CloseIcon from "../../assets/crossIcon.svg";
import { getProcedureList, getScheduledTime } from "./DelayMarkingAPIHandler";
import {
  CREATE_UPDATE_DELAY_SCHEDULE,
  GET_CONSULTATION_LIST,
  GET_SCHEDULED_TIME,
} from "./DelayMarkingAPIHandler/APIconstants";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { APIFILTERLIST } from "../DashboardAppointmentsView/Constant";
import { Dialog } from "@material-ui/core";
import Loader from "../../assets/C2C Loader.gif";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import { c2cPostApiHandler } from "../../Util/c2cApiHandler";

const DelayMarkingModal = (props) => {
  const {
    open,
    selectedConsultation,
    handleClose,
    handleReviewChanges,
    handleConsultationDropDown,
    doctorName,
    doctorId,
  } = props;
  const userType = localStorage.getItem("user_type");
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  const [consultationList, setConsultationList] = useState([]);
  const [scheduledTime, setScheduledTime] = useState([]);
  const [disableReviewBtn, setDisableReviewBtn] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  const location = useLocation();

  const selectedDate = new URLSearchParams(location.search).get(
    APIFILTERLIST.STARTDATE
  );

  const styles = {
    control: (base) => ({
      ...base,
      width: "100%",
      background: " #F5F6F7 0% 0% no-repeat padding-box",
      boxShadow: "none",
      border: "none",
      cursor: "pointer",
      height: "20px",
      "&:hover": {
        boxShadow: "none",
      },
    }),
    menuList: (provided) => ({
      ...provided,
      cursor: "pointer",
      maxHeight: "130px",
      paddingTop: "0px",
      "&::-webkit-scrollbar": {
        width: "16px",
        height: " 16px",
        display: "block !important",
        background: "none",
      },
      "&::-webkit-scrollbar-track": {
        background: "none",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        boxShadow: "inset 0 0 16px rgba(240, 232, 232, 1)",
        minHeight: "60px !important",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#888",
      },
    }),
  };
  //   <===== Lifecycle

  useEffect(() => {
    if (open) {
      getProcedureListAPICall();
    }
  }, [open]);

  useEffect(() => {
    if (selectedConsultation) {
      let getDelayConsultationList = JSON.parse(
        localStorage.getItem("delayMarkingSlotsList")
      );
      if (getDelayConsultationList) {
        setScheduledTime(getDelayConsultationList);
        setDisableReviewBtn(false);
        setShowLoader(false);
      } else {
        getScheduledTimeAPICall();
      }
    }
  }, [selectedConsultation]);

  // =====>

  // Helper Methods ===>

  const handleDisableReviewBtn = (data) => {
    let isDisabled = data.filter((dt) => dt.hasEndError || dt.hasStartError);
    if (isDisabled.length !== 0) {
      setDisableReviewBtn(true);
    } else {
      setDisableReviewBtn(false);
    }
  };

  const handleStartTime = (data, index) => {
    let e_time =
      data[index].end_hr +
      ":" +
      data[index].end_min +
      " " +
      data[index].end_meridiem;
    let time =
      data[index].start_hr +
      ":" +
      data[index].start_min +
      " " +
      data[index].start_meridiem;

    if (
      data[index].end_hr !== "" &&
      data[index].end_hr !== "0" &&
      data[index].end_min !== ""
    ) {
      data[index].hasEndError = false;
    }
    if (
      moment(time, "HH:mm a").isBefore(
        moment(data[index].start_time, "HH:mm a")
      ) ||
      moment(time, "HH:mm a").isSameOrAfter(moment(e_time, "HH:mm a"))
    ) {
      data[index].hasStartError = true;
    } else {
      data[index].hasStartError = false;
    }
    return data;
  };

  const handleEndTime = (data, index) => {
    let s_time =
      data[index].start_hr +
      ":" +
      data[index].start_min +
      " " +
      data[index].start_meridiem;
    let time =
      data[index].end_hr +
      ":" +
      data[index].end_min +
      " " +
      data[index].end_meridiem;
    if (
      !moment(s_time, "HH:mm a").isSameOrBefore(
        moment(data[index].start_time, "HH:mm a")
      ) &&
      data[index].start_hr !== "" &&
      data[index].start_hr !== "0" &&
      data[index].start_min !== ""
    ) {
      data[index].hasStartError = false;
    }
    if (data.length > 1) {
      if (index + 1 === data.length) {
        data = checkValidEndTime(data, index, s_time, time);
      } else {
        if (
          moment(time, "HH:mm a").isSameOrBefore(
            moment(data[index].start_time, "HH:mm a")
          ) ||
          moment(time, "HH:mm a").isSameOrBefore(moment(s_time, "HH:mm a"))
        ) {
          data[index].hasEndError = true;
          data[index].end_message = "Please enter a valid time";
        } else if (
          moment(time, "HH:mm a").isAfter(
            moment(data[index + 1].start_time, "HH:mm a")
          )
        ) {
          data[index].hasEndError = true;
          data[index].end_message = "Slot overlap is not possible";
        } else {
          data[index].hasEndError = false;
          data[index].end_message = "";
        }
      }
    } else {
      data = checkValidEndTime(data, index, s_time, time);
    }
    return data;
  };

  const checkValidEndTime = (data, index, s_time, time) => {
    if (
      moment(time, "HH:mm a").isSameOrBefore(
        moment(data[index].start_time, "HH:mm a")
      ) ||
      moment(time, "HH:mm a").isSameOrBefore(moment(s_time, "HH:mm a"))
    ) {
      data[index].hasEndError = true;
      data[index].end_message = "Please enter a valid time";
    } else {
      data[index].hasEndError = false;
    }
    return data;
  };

  // <===

  const getProcedureListAPICall = async () => {
    let reqPayload = {
      doctor_id: doctorId,
      ...(clinicId && { clinic_id: clinicId }),
      date_selected: selectedDate,
    };
    const procedureListResponse = getProcedureList(
      reqPayload,
      GET_CONSULTATION_LIST
    ); //Fetch API Data
    procedureListResponse.then(([res, error]) => {
      if (!error) {
        setConsultationList(res);
        !selectedConsultation && handleConsultationDropDown(res[0]);
      } else {
        C2CConsole.log("something went wrong");
      }
    });
  };

  const getScheduledTimeAPICall = () => {
    setShowLoader(true);
    let reqPayload = {
      doctor_id: doctorId,
      date: selectedDate,
      consultation_type: selectedConsultation?.consultation_type,
      ...(selectedConsultation.consultation_type === "4" && {
        procedure_id: selectedConsultation?.value,
      }),
      ...(clinicId && { clinic_id: clinicId }),
    };
    const scheduledTimeResponse = getScheduledTime(
      reqPayload,
      GET_SCHEDULED_TIME
    ); //Fetch API Data
    scheduledTimeResponse.then(([res, error]) => {
      if (!error) {
        setScheduledTime(res);
        localStorage.setItem("delayMarkingSlotsList", JSON.stringify(res));
        setShowLoader(false);
      } else {
        C2CConsole.log("something went wrong");
        setShowLoader(false);
      }
    });
  };

  const createDelayScheduleAPI = () => {
    const selectedTime = scheduledTime.filter((data) => data.checked === true);
    if (selectedTime.length > 0) {
      let obj = selectedTime[0];
      let startTime =
        obj.start_hr + ":" + obj.start_min + " " + obj.start_meridiem;
      let endTime = obj.end_hr + ":" + obj.end_min + " " + obj.end_meridiem;
      let reqPayload = {
        doctor_id: doctorId,
        date: selectedDate,
        schedule_id: obj.doctor_schedule_id,
        start_time: moment(startTime, "HH:mm A").format("HH:mm:ssZ"),
        end_time: moment(endTime, "HH:mm A").format("HH:mm:ssZ"),
        user_id: userType === "staff" ? staffId : userId,
        user_type: userType === "staff" ? "4" : "1",
        user_agent: "web",
        status: "0",
      };
      const createDelayResponse = c2cPostApiHandler(
        CREATE_UPDATE_DELAY_SCHEDULE,
        reqPayload
      ); //Fetch API Data
      createDelayResponse.then(([res, error]) => {
        if (!error) {
          if (res.data.statusCode === 200) {
            handleReviewChanges(res?.data?.delay_id);
          }
        } else {
          C2CConsole.log("something went wrong");
        }
      });
    }
  };

  const handleRadioBtn = (e) => {
    let selectedTime = [...scheduledTime];
    const scheduledTimeIndex = scheduledTime.findIndex(
      (data) => data.doctor_schedule_id === e.target.value
    );
    selectedTime.forEach((data) => {
      data.checked = false;
      data.hasEndError = false;
      data.hasStartError = false;
      data.start_hr = data.temp_start_hr;
      data.start_min = data.temp_start_min;
      data.start_meridiem = data.temp_start_meridiem;
      data.end_hr = data.temp_end_hr;
      data.end_min = data.temp_end_min;
      data.end_meridiem = data.temp_end_meridiem;
      data.start_message = "";
      data.end_message = "";
    });
    selectedTime[scheduledTimeIndex].checked = true;
    setScheduledTime(selectedTime);
    setDisableReviewBtn(true);
  };

  const handleHr = (e, doctor_schedule_id) => {
    let data = [...scheduledTime];
    const index = data.findIndex(
      (d) => d?.doctor_schedule_id === doctor_schedule_id
    );
    if (e.target.value.length <= 2) {
      if (e.target.value <= 12) {
        if (e.target.name === "start_time") {
          data[index].start_hr = e.target.value;
          data = handleStartTime(data, index);
        } else if (e.target.name === "end_time") {
          data[index].end_hr = e.target.value;
          data = handleEndTime(data, index);
        }
      }
      setScheduledTime(data);
    }
    if (data[index].end_hr == 0 || data[index].end_hr == "") {
      data[index].hasEndError = true;
      data[index].end_message = "Please enter a valid time";
      setScheduledTime(data);
    }
    if (data[index].start_hr == 0 || data[index].start_hr == "") {
      data[index].hasStartError = true;
      data[index].start_message = "Please enter a valid time";
      setScheduledTime(data);
    }

    handleDisableReviewBtn(data);

    localStorage.setItem("delayMarkingSlotsList", JSON.stringify(data));
  };

  const handleMin = (e, doctor_schedule_id) => {
    let data = [...scheduledTime];
    const index = data.findIndex(
      (d) => d?.doctor_schedule_id === doctor_schedule_id
    );
    if (e.target.value.length <= 2) {
      if (e.target.value <= 59) {
        if (e.target.name === "start_time") {
          data[index].start_min = e.target.value;
          data = handleStartTime(data, index);
        } else if (e.target.name === "end_time") {
          data[index].end_min = e.target.value;
          data = handleEndTime(data, index);
        }
      }
      setScheduledTime(data);
    }
    if (data[index].end_min == "" || data[index].end_hr == "") {
      data[index].hasEndError = true;
      data[index].end_message = "Please enter a valid time";
      setScheduledTime(data);
    }
    if (data[index].start_min == "" || data[index].start_hr == "") {
      data[index].hasStartError = true;
      data[index].start_message = "Please enter a valid time";
      setScheduledTime(data);
    }

    handleDisableReviewBtn(data);

    localStorage.setItem("delayMarkingSlotsList", JSON.stringify(data));
  };

  const handleMeridiem = (e, doctor_schedule_id) => {
    let data = [...scheduledTime];
    const index = data.findIndex(
      (d) => d?.doctor_schedule_id === doctor_schedule_id
    );
    if (e.target.name === "start_time") {
      data[index].start_meridiem = e.target.value;
      data = handleStartTime(data, index);
    } else if (e.target.name === "end_time") {
      data[index].end_meridiem = e.target.value;
      data = handleEndTime(data, index);
    }
    setScheduledTime(data);

    handleDisableReviewBtn(data);

    localStorage.setItem("delayMarkingSlotsList", JSON.stringify(data));
  };

  const handleReview = () => {
    createDelayScheduleAPI();
  };

  const renderHeader = () => {
    return (
      <div className="d-flex justify-content-between p-3 border-btm">
        <div className="delay-heading">Delay Marking</div>
        <div className="delay-close-icon" onClick={handleClose}>
          {"Close"} <img src={CloseIcon} alt="" />
        </div>
      </div>
    );
  };

  const renderDoctorNameAndConsultationList = () => {
    return (
      <div className="d-flex justify-content-between px-3 py-2 flex-sm-column flex-lg-row flex-column">
        <div>
          <div className="delay-input-label">Doctor Name</div>
          <div className="delay-doctor-name">{doctorName}</div>
        </div>
        <div className="delay-consultation-dropdown">
          <CustomSelect
            className="select_dropdownOptions"
            showSearch={false}
            placeholder=""
            options={consultationList}
            value={selectedConsultation ? selectedConsultation : ""}
            handleChange={handleConsultationDropDown}
            fixedBottomBtn={false}
            isSearchable={false}
            customStyles={styles}
          />
        </div>
      </div>
    );
  };

  const renderDelayTimePicker = () => {
    return (
      <>
        {showLoader ? (
          <div className="d-flex justify-content-center timepicker-wrapper-container">
            <img src={Loader} alt="" style={{ height: "80px" }} />
          </div>
        ) : (
          <div className="timepicker-wrapper-container">
            {scheduledTime?.length > 0 &&
              scheduledTime.map((data, indx) => (
                <div
                  className={`mx-3 py-3 ${
                    scheduledTime?.length > 1 && indx < scheduledTime.length - 1
                      ? "timepicker-wrapper"
                      : ""
                  }`}
                >
                  <DelayTimeWrapper
                    isSingleSlot={scheduledTime?.length > 1 ? true : false}
                    data={data}
                    handleRadioBtn={handleRadioBtn}
                    handleHr={handleHr}
                    handleMin={handleMin}
                    handleMeridiem={handleMeridiem}
                  />
                </div>
              ))}
          </div>
        )}
      </>
    );
  };

  const renderDelayButton = () => {
    return (
      <div className="delay-button-container d-flex p-3 justify-content-end">
        <button className="cancel-btn" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="mark-delay-btn"
          onClick={handleReview}
          disabled={disableReviewBtn}
        >
          Review Changes
        </button>
      </div>
    );
  };

  return (
    <>
      <Dialog open={open} className="delay-marking-modal">
        <div className="delay-modal-container">
          {renderHeader()}
          {renderDoctorNameAndConsultationList()}
          {renderDelayTimePicker()}
          {renderDelayButton()}
        </div>
      </Dialog>
    </>
  );
};

export default DelayMarkingModal;
